// eslint-disable-next-line check-file/folder-naming-convention
import { createFileRoute } from '@tanstack/react-router'
import { LandingRedirectContent } from 'pages/redirects/LandingRedirectContent'

export const Route = createFileRoute('/_redirects/landing')({
  component: RouteComponent,
})

function RouteComponent() {
  return <LandingRedirectContent />
}
